import { Controller } from "stimulus"

export default class extends Controller {
  static values = { total: Number }
  static targets = ["reloadButton"]

  connect() {
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  onFrameLoad = () => {
    const doneCount = this.element.querySelectorAll("[data-poll-stop]").length
    if (doneCount >= this.totalValue) {
      this.reloadButtonTarget.classList.remove("hidden")
    }
  }
}
